import Config from "@/utils/config"
import {
	login
} from "@/api/auth/login"
import {
	adList
} from "@/api/website"
import {
	noticesList
} from "@/api/cms/notice"
import {
	floors,
	floatLayer,
	indexnews,
	apiDefaultSearchWords,
	apiHotSearchWords
} from "@/api/pc"
 
import {
	mapGetters
} from "vuex"
import {
	couponList,
	receiveCoupon
} from "@/api/coupon"
import {
	goodsPage,
	timeList
} from "@/api/seckill"
import CountDown from "vue2-countdown"
import {
		helpList
	} from "@/api/cms/help"
export default {
	name: "index",
	components: {
		CountDown
	},
	data: () => {
		return {
			loadingAd: true,
			loadingFloor: true,
			adList: [],
			adLeftList: [],
			adRightList: [],
			adbottom: [],
			couponList: [],
			floorList: [],
			floatLayer: {
				is_show: false,
				link: {
					url: ""
				}
			},
			indexFloatLayerNum: 0,
			isSub: false,
			siteId: 0,
			listData: [],
			seckillTimeMachine: {
				currentTime: 0,
				startTime: 0,
				endTime: 0
			},
			seckillText: "距离结束",
			backgroundColor: "", // 顶部banner背景颜色
			// 悬浮搜索
			searchType: "goods",
			searchTypeText: "商品",
			hotSearchWords: [], 
			keyword: "",
			defaultSearchWords: "",
			isShow: false,
			hotNewsList: [],
			induNewsList:[],
			helpList: [],
			helpcurlist:[],
			helpclassindex:0,
			curcourseindex:0,
			imgVisible:false,
			attrimgsrc:'',
			select_cat_id:0
		}
	},
	watch: {
		searchType() {
			this.searchTypeText = this.searchType == "goods" ? "商品" : "店铺"
		}
	},
	created() {
		this.getAdList()
		this.getBigAdList()
		this.getSmallAdList()
		this.getBottomAdList()
		this.getFloors()
		this.getFloatLayer()
		this.$store.dispatch("site/siteInfo") // 站点信息
		this.getDefaultSearchWords() // 默认搜索类型
		if(this.addonIsExit && this.addonIsExit.seckill == 1){
			this.getTimeList()
		}		
		this.getCanReceiveCouponQuery()
		this.getHotSearchWords()
		this.getHotNews()
		this.getInduNews()
		this.getHelpList()
	},
	mounted() {
		//window.addEventListener("scroll", this.handleScroll)
		 
	},
	computed: {
		...mapGetters(["defaultHeadImage", "addonIsExit", "defaultGoodsImage", "member", "siteInfo", "cartCount"]),
		optionLeft() {
			return {
				direction: 2,
				limitMoveNum: 2
			}
		}
	},
	methods: {
		countDownS_cb() {},
		countDownE_cb() {
			this.seckillText = "活动已结束"
		},
		 change_sj_desc(type) {
		       this.curcourseindex=type;
		       this.$refs.carousel.setActiveItem(type)
		     },
		
		getHotSearchWords() {
			apiHotSearchWords({}).then(res => { 
				if (res.code == 0 && res.data.words) {
					this.hotSearchWords = res.data.words.split(',');
				}
			});
		},
		getAdList() {
			adList({
					keyword: "NS_PC_INDEX"
				})
				.then(res => {
					console.log('----------------------',JSON.stringify(res))
					let tmptitle=''; 
					this.adList = res.data.adv_list
					this.$store.dispatch("app/is_show", {
						is_show:this.adList.length
					}).then(res => {})
					for (let i = 0; i < this.adList.length; i++) {
						tmptitle=this.adList[i].adv_title;
						let tmptitlearr=tmptitle.split("-"); 
						this.adList[i].title1=tmptitlearr[0];
						if(tmptitlearr[1]){
							
							this.adList[i].title2=tmptitlearr[1]; 
						}
						if (this.adList[i].adv_url) this.adList[i].adv_url = JSON.parse(this.adList[i].adv_url)
						
						
					}
					//console.log(",,,,,,,,,,,,,,,,,,,",JSON.stringify(this.adList))
					this.backgroundColor = this.adList[0].background
					this.loadingAd = false
				})
				.catch(err => {
					this.loadingAd = false
				})
		},
		handleChange(curr, pre) {
		    //console.log("...............",curr);
			this.curcourseindex=curr;
			this.backgroundColor = this.adList[curr].background
		},
		/**
		 * 广告位大图
		 */
		getBigAdList() {
			adList({
					keyword: "NS_PC_INDEX_MID_LEFT"
				})
				.then(res => {
					this.adLeftList = res.data.adv_list
					for (let i = 0; i < this.adLeftList.length; i++) {
						if (this.adLeftList[i].adv_url) this.adLeftList[i].adv_url = JSON.parse(this.adLeftList[i].adv_url)
					}
					//console.log("...........",JSON.stringify(this.adLeftList));
					this.loadingAd = false
				})
				.catch(err => {
					this.loadingAd = false
				})
		},
		/**
		 * 广告位小图
		 */
		getSmallAdList() {
			adList({
					keyword: "NS_PC_INDEX_MID_RIGHT"
				})
				.then(res => {
					this.adRightList = res.data.adv_list
					for (let i = 0; i < this.adRightList.length; i++) {
						if (this.adRightList[i].adv_url) this.adRightList[i].adv_url = JSON.parse(this.adRightList[i].adv_url)
					}
					this.loadingAd = false
				})
				.catch(err => {
					this.loadingAd = false
				})
		},
		getBottomAdList() {
			adList({
					keyword: "NS_PC_INDEX_BOTTOM_TRADE"
				})
				.then(res => {
					this.adbottom = res.data.adv_list
					for (let i = 0; i < this.adbottom.length; i++) {
						if (this.adbottom[i].adv_url) this.adbottom[i].adv_url = JSON.parse(this.adbottom[i].adv_url)
					}
					this.loadingAd = false
				})
				.catch(err => {
					this.loadingAd = false
				})
		},
		openbigimg(imgsrc){
			 this.attrimgsrc='../assets/images/loading.gif';
			 this.imgVisible=true;
		     //this.attrimgsrc=this.$util.img(imgsrc);
			 var newImg = new Image();
			 newImg.src = this.$util.img(imgsrc); 
			 newImg.onload = () => {  
			     this.attrimgsrc = newImg.src
			 }
		},
		attrimgClose(){
			this.imgVisible=false;
		},  
		//获取优惠券列表
		getCanReceiveCouponQuery() {
			couponList({
					activeName: "second",
					site_id: this.siteId
				})
				.then(res => {
					console.log(res,'获取优惠券列表')
					let data = res.data
					this.couponList = []
					if (data != null) {
						for (let i = 0; i < data.list.length; i++) {
							if (i < 5) {
								this.couponList.push(data.list[i])
							}
						}
						this.couponList.forEach(v => {
							v.useState = 0
						})
					}
				})
				.catch(err => {})
		},
		/**
		 * 领取优惠券
		 */
		receiveCoupon(item, index) {
			console.log(item, index)
			if (this.isSub) return
			this.isSub = true

			var data = {
				site_id: item.site_id,
				activeName: "second",
				coupon_type_id: item.coupon_type_id
			}
			receiveCoupon(data)
				.then(res => {
					console.log(res,'领取优惠券')
					var data = res.data
					let msg = res.message
					if (res.code == 0) {
						msg = "领取成功"
						this.$message({
							message: msg,
							type: "success"
						})
					} else {
						console.log('领取优惠券')
						this.$message({
							message: msg,
							type: "warning"
						})
					}
					let list = this.couponList
					if (res.data.is_exist == 1) {
						for (let i = 0; i < list.length; i++) {
							if (list[i].coupon_type_id == item.coupon_type_id) {
								list[i].useState = 1
							}
						}
					} else {
						for (let i = 0; i < list.length; i++) {
							if (list[i].coupon_type_id == item.coupon_type_id) {
								list[i].useState = 2
							}
						}
					}

					this.isSub = false
					this.$forceUpdate()
				})
				.catch(err => {
					if( err.message == '您尚未登录，请先进行登录' ){
						this.$router.push('/login');
					} else {
						this.$message.error(err.message)
					}
					this.isSub = false
				})
		},
		/**
		 * 点击优惠券
		 */
		couponTap(item, index) {
			if (item.useState == 0) this.receiveCoupon(item, index)
			else this.toGoodsList(item)
		},
		/**
		 * 去购买
		 */
		toGoodsList(item) {
			if (item.use_scenario != 1) {
				this.$router.push({
					path: "/list",
					query: {
						platformcouponTypeId: item.platformcoupon_type_id
					}
				})
			} else {
				this.$router.push("/list")
			}
		},
		opentardeurl(url){
			this.$router.push(url)
		},
		/**
		 * 限时秒杀
		 */
		getTimeList() {
			timeList()
				.then(res => {
					if (res.code == 0 && res.data) {
						let time = new Date(res.timestamp * 1000)
						let currentTimes = time.getHours() * 60 * 60 + time.getMinutes() * 60 + time.getSeconds()

						res.data.list.forEach((v, k) => {
							if (v.seckill_start_time <= currentTimes && currentTimes < v.seckill_end_time) {
								let seckillId = v.seckill_id
								this.getGoodsList(seckillId)

								let endTime = parseInt(time.getTime() / 1000) + (v.seckill_end_time - currentTimes)
								this.seckillTimeMachine = {
									currentTime: res.timestamp,
									startTime: res.timestamp,
									endTime: endTime
								}
							}
						})
					}
				})
				.catch(err => {
					// this.$message.error(err.message)
				})
		},
		/**
		 * 秒杀商品
		 */
		getGoodsList(id) {
			goodsPage({
					page_size: 0,
					seckill_id: id,
					site_id: this.siteId
				})
				.then(res => {
					if (res.code == 0 && res.data.list) {
						this.listData = res.data.list
					}
				})
				.catch(err => {})
		},
		/**
		 * 图片加载失败
		 */
		imageError(index) {
			this.listData[index].sku_image = this.defaultGoodsImage
		},
		/**
		 * 图片加载失败
		 */
		adLeftImageError(index) {
			this.adLeftList[index].adv_image = this.defaultGoodsImage
		},
		/**
		 * 图片加载失败
		 */
		adRightImageError(index) {
			this.adRightList[index].adv_image = this.defaultGoodsImage
		},
		getFloors() {
			floors()
				.then(res => {
					this.floorList = res.data;
				})
				.catch(err => {
					console.log(err)
				})
		},
		getFloatLayer() {
			floatLayer()
				.then(res => {
					if (res.code == 0 && res.data) {
						this.floatLayer = res.data	
						if(this.floatLayer.is_show == 1){
							this.floatLayer.link = JSON.parse(this.floatLayer.url)
							// 弹框形式，首次弹出 1，每次弹出 0
							if (!this.floatLayer.img_url) return
							var index_popwindow_count = this.$store.state.app.indexFloatLayerNum;						
							if (parseInt(this.floatLayer.number) >= 1) {												
								//缓存计数 == 弹出总数   禁止弹出						
								if(index_popwindow_count >= parseInt(this.floatLayer.number)){							
									this.floatLayer.is_show_type = false
								}else{
									this.floatLayer.is_show_type = true
								}							
							} else if (parseInt(this.floatLayer.number) == 0) {
								this.floatLayer.is_show_type = true							
							}
						}else{
							this.floatLayer.is_show_type = false	
						}
						
					}
				})
				.catch(err => err)
		},
		closeFloat() {
			var index_popwindow_count = this.$store.state.app.indexFloatLayerNum;
			if(parseInt(this.floatLayer.number) == 0){
				this.$store.commit("app/SET_FLOAT_LAYER", 0)
			}else if(parseInt(this.floatLayer.number) >= 1 && index_popwindow_count != parseInt(this.floatLayer.number)) {
				var count_num = index_popwindow_count + 1;
				this.$store.commit("app/SET_FLOAT_LAYER", count_num)
			}else if(index_popwindow_count == parseInt(this.floatLayer.number)){
				this.$store.commit("app/SET_FLOAT_LAYER", this.floatLayer.number)
			}
			this.floatLayer.is_show_type = false
			this.$forceUpdate()
			// this.$store.commit("app/SET_FLOAT_LAYER", -1)
		},
		// 监听滚动条
		handleScroll() {
			var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop

			if (scrollTop >= 680) {
				this.isShow = true
			} else {
				this.isShow = false
			}
		},
		destroyed() {
			// 离开该页面需要移除这个监听的事件，不然会报错
			//window.removeEventListener("scroll", this.handleScroll)
		},
		/**
		 * 默认搜索类型（goods/shop）
		 */
		getDefaultSearchWords() {
			apiDefaultSearchWords({}).then(res => {
				if (res.code == 0 && res.data.words) {
					this.defaultSearchWords = res.data.words
				}
			})
		},
		handleCommand(command) {
			this.searchType = command
		},
		search() { 
			if (this.searchType == "goods") this.$router.push({
				path: "/list",
				query: {
					category_id:this.select_cat_id,
					level:0,
					keyword: this.keyword
				}
			})
			else this.$router.push({
				path: "/street",
				query: {
					keyword: this.keyword
				}
			})
		},
		getHotNews() {
			indexnews({ 
					classid: 5,
					newsum:2
				})
				.then(res => {
					  
					 this.hotNewsList = res.data;
					 //console.log('..hotnews.',JSON.stringify(this.hotNewsList));
				})
				.catch(err => {
					console.log(err)
				})
		},
		getInduNews() {
			indexnews({ 
					classid: 6,
					newsum:6
				})
				.then(res => {
					  
					 this.induNewsList = res.data;
					  
				})
				.catch(err => {
					console.log(err)
				})
		},
			/**
			 * 获取帮助列表
			 */
			getHelpList() {
				helpList()
					.then(res => {
						if (res.code == 0 && res.data) {
							var arr = [];
							arr = res.data.slice(0, 6)
							console.log(arr)
							for (let i = 0; i < arr.length; i++) {
								arr[i].child_list = arr[i].child_list.slice(0, 6);
							}

							this.helpList = arr;
							this.helpcurlist=arr[0];
							console.log('.............',JSON.stringify(this.helpcurlist))
						}
					})
					.catch(err => {})
            },
			/**
			 * 跳转到帮助列表
			 */
			changeHelpClass(id) {
				 this.helpclassindex=id;
				 this.helpcurlist=this.helpList[id];
			},
			/**
			 * 跳转到帮助详情
			 */
			clickToHelpDetail(id) {
				this.$router.push("/cms/help-" + id)
			},
			clickTocenter() {
				this.$router.push({ path: '/list', query: { category_id: 0, level: 1 } })
			},
			clickTohall() {
				this.$router.push({ path: '/spotgoods', query: { category_id: 0, level: 1 } })
			},
			/**
			 * 跳转到帮助详情
			 */
			clickJump(address) {
				location.href= address;
			}
	}
}
